import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "nav-link"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Accueil")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_router_link, {
        to: "/collection",
        class: "nav-link"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Cartes Postales")
        ])),
        _: 1,
        __: [1]
      })
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, "Made with 🌺🌼🌷🌻🌹🪻🌸🏵️ by Julie", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", null, " © 2021 Niantic, Inc., Pikmin and Mii Characters / Artwork / Music © 2021 Nintendo All Rights Reserved. ", -1))
  ]))
}